//-- Copyright (c) 2021 TMT Insights Group, LLC
import { useState } from 'react';
import { Button, Input, Stack, Typography } from '@mui/material';
import axios from '@/_utils/axios';
import { FocusVersionScheduling } from '@/redux/slices/slice_types';
import { Spinner } from '@/components/_common';

const AvailsAdmin = () => {
  const [brandId, setBrandId] = useState<string | null>('');
  const [deletedItems, setDeletedItems] = useState<string[]>([]);
  const [loading, setLoading] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setBrandId(e.target.value);
  };

  const deleteSchedule = (scheduleId: number) => {
    return axios.delete(`focus/scheduling/${scheduleId}/`).then(() => {
      return scheduleId;
    });
  };

  const deleteBrand = () => {
    setLoading(true);
    axios.post('focus/scheduling/search/?page_size=9999&page_num=0', { search: brandId }, { baseURL: '/api/v1.1' }).then((res) => {
      const schedules = res.data.data as FocusVersionScheduling[];
      const schedulesToDelete = schedules.reduce((acc, schedule) => {
        acc.push(deleteSchedule(schedule.id));
        return acc;
      }, [] as Promise[]);
      Promise.all(schedulesToDelete)
        .then(() => {
          setDeletedItems(schedulesToDelete.map((schedule) => schedule.id));
        })
        .catch((error) => {
          console.error(error);
          setDeletedItems(schedulesToDelete.map((schedule) => schedule.id));
        })
        .finally(() => {
          setLoading(false);
        });
    });
  };

  return (
    <Stack sx={{ padding: '100px', gap: '10px', width: '400px' }}>
      <Typography>Enter in a brand id (like TWM) to delete Focus data</Typography>
      <Input value={brandId} onChange={handleChange} placeholder="Brand Id" />
      <Button variant="contained" color="error" onClick={deleteBrand}>
        Delete
      </Button>
      {loading && <Spinner />}
      {deletedItems.length > 0 && (
        <>
          <Typography>Deleted {deletedItems.length} Schedules</Typography>
        </>
      )}
    </Stack>
  );
};

export default AvailsAdmin;
